import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import {
  MODAL_SIZES,
  ModalState,
  OpenModalPayload,
} from "../../../entities/Modal";

const initialState: ModalState = {
  isOpen: false,
  modalType: null,
  content: {},
  size: null,
  rootCause: null,
};

export const modalSlice = createSlice({
  name: "modalSlice",
  initialState,
  reducers: {
    onOpenModal: (
      state: ModalState,
      action: PayloadAction<OpenModalPayload>,
    ) => {
      state.isOpen = true;
      state.modalType = action.payload.modalType;
      state.content = action.payload.content;
      state.size = action.payload.size ?? MODAL_SIZES.XL;
      state.rootCause = action.payload.rootCause ?? null;
      document.body.style.overflow = "hidden";
    },
    onCloseModal: (state: ModalState) => {
      state.isOpen = false;
      state.modalType = null;
      state.content = {};
      state.size = null;
      document.body.style.overflow = "auto";
    },
  },
});

export const { onOpenModal, onCloseModal } = modalSlice.actions;

export default modalSlice.reducer;
